import { render } from "./purchases_providers_report.vue?vue&type=template&id=1fac512b&scoped=true"
import script from "./purchases_providers_report.vue?vue&type=script&lang=js"
export * from "./purchases_providers_report.vue?vue&type=script&lang=js"

import "./purchases_providers_report.vue?vue&type=style&index=0&id=1fac512b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fac512b"]])

export default __exports__